export const toCents = (decimalPrice: number) => {
  return Math.round(parseFloat(decimalPrice.toString()) * 100);
};
export const parseCents = (cents: number | string) => {
  const parsed = typeof cents === "string" ? parseInt(cents, 10) : cents;
  return isNaN(parsed) ? 0 : parsed / 100;
};
